import { create } from 'zustand';

import { PinturaEditor, PinturaImageState } from '@pqina/pintura';
import { type Decoration } from '@api';

type EditorStore = {
  // UI STate
  zoomInputEnabled: boolean;
  rotationInputEnabled: boolean;
  imageFlipX: boolean;
  toggleImageFlipX: () => void;
  enableZoomInput: () => void;
  enableRotationInput: () => void;
  resetStore: () => void;
  editor: PinturaEditor | undefined;
  setEditor: (editor: PinturaEditor | undefined) => void;
  imageState: PinturaImageState;
  setImageState: (state: PinturaImageState) => void;
  setCropAreaSize: (size: { width: number; height: number }) => void;
  setCropAreaCoordinates: (coordinates: { x: number; y: number }) => void;
  cropAreaSize: { width: number; height: number };
  cropAreaCoordinates: { x: number; y: number };
  decoration?: Decoration;
  tempImage: File | undefined;
  setTempImage: (tempImage: File | undefined) => void;
  setDecoration: (decoration: Decoration | undefined) => void;
};

export const useEditorStore = create<EditorStore>()((set) => ({
  // UI STate
  zoomInputEnabled: true,
  rotationInputEnabled: false,
  imageFlipX: false,
  enableZoomInput: () => {
    set(() => ({
      zoomInputEnabled: true,
      rotationInputEnabled: false,
    }));
  },
  enableRotationInput: () => {
    set(() => ({
      zoomInputEnabled: false,
      rotationInputEnabled: true,
    }));
  },
  resetStore: () => {
    set({
      zoomInputEnabled: true,
      rotationInputEnabled: false,
      editor: undefined,
      imageState: {},
      cropAreaSize: { width: 0, height: 0 },
      cropAreaCoordinates: { x: 0, y: 0 },
      imageFlipX: false,
      decoration: undefined,
    });
  },
  editor: undefined,
  setEditor: (editor: PinturaEditor | undefined) => {
    console.log('EditorStore setEditor', editor);
    set({ editor: editor });
  },
  imageState: {},
  setImageState: (state: PinturaImageState) => {
    set({ imageState: state });
  },
  cropAreaSize: { width: 0, height: 0 },
  setCropAreaSize: (size: { width: number; height: number }) => {
    set({ cropAreaSize: size });
  },
  cropAreaCoordinates: { x: 0, y: 0 },
  setCropAreaCoordinates: (coordinates: { x: number; y: number }) => {
    set({ cropAreaCoordinates: coordinates });
  },
  toggleImageFlipX: () => set((state) => ({ imageFlipX: !state.imageFlipX })),
  decoration: undefined,
  setDecoration: (decoration: Decoration | undefined) => {
    set({ decoration });
  },
  tempImage: undefined,
  setTempImage: (tempImage: File | undefined) => {
    set({ tempImage });
  },
}));
